import { render, staticRenderFns } from "./QC.vue?vue&type=template&id=4288afa4&scoped=true"
import script from "./QC.vue?vue&type=script&lang=js"
export * from "./QC.vue?vue&type=script&lang=js"
import style0 from "./QC.vue?vue&type=style&index=0&id=4288afa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288afa4",
  null
  
)

export default component.exports